const getScrollbarWidth = () => {
  const properties = { visibility: 'hidden', overflow: 'scroll',  msOverflowStyle: 'scrollbar' };

  const outer = document.createElement('div');
  const inner = document.createElement('div');

  Object.entries(properties).forEach(([key, value]) => outer.style[key] = value);
  document.body.appendChild(outer);
  outer.appendChild(inner);

  const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;
  outer.parentNode.removeChild(outer);

  return scrollbarWidth;
}

export default getScrollbarWidth;